
export const FITNESS_LISTS_ROUTES = {
    EXERCISES_LIST: "/exercises",
    WORKOUT_TYPES_LIST: "/workout-types",
    WORKOUTS_LIST: "/workouts",
    HOMEPAGE_LAYOUT_LIST: "/homepage-layout"
};
